import * as types from '../types';

const initialState = {
  TenantName: null,
  TenantId: null,
  clientid: null,
  domain:  null,
  prefix:  null,
  demoUrl: null
};

export default (state = initialState, action) => {
    switch (action.type) {

        case types.ON_APPSETTINGS_SUCCESS: {
            return {
                ...state,
                TenantName: action.payload.TenantName,
                TenantId: action.payload.TenantId,
                clientid: action.payload.clientid,
                domain: action.payload.domain,
                prefix: action.payload.prefix,
                demoUrl: action.payload.demoUrl,
                redirectUris: action.payload.redirectUris
            };
        }
        default:
            return state;
    }
};
